import AbstractCommand from "../../../../../../shared/src/ranj/app/core/AbstractCommand";
import SkinKeys from "../../../../../../shared/src/ranj/app/ui/SkinKeys";
import GameModel from "../model/GameModel";


export default class GameCompletedCommand extends AbstractCommand {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     * @param {GameModel} gameModel 
     */
     constructor(dispatcher, gameModel) {
        super(dispatcher);

        this.execute = function(event) {
            this.gotoScreen(SkinKeys.END_SCREEN);
        };
    }

}